// Vendors
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';
import styled from 'styled-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const ContractOtpWrapperStyled = styled.div`
  line-height: ${FoundationsCobrandedRegularTheme.font_line_height_paragraph_medium};
  width: ${convertPxsToRems({ pixels: 260, base: 16 })};
  margin: auto;
  gap: ${FoundationsCobrandedRegularTheme.spacing_300};
  display: flex;
  flex-direction: column;
  position: relative;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.onlyMobile} {
    width: 100%;
  }
`;
ContractOtpWrapperStyled.displayName = 'ContractOtpWrapperStyled';

const ContractOtpDescriptionWrapperStyled = styled.div`
  text-align: center;
`;
ContractOtpDescriptionWrapperStyled.displayName = 'ContractOtpDescriptionWrapperStyled';

const HashedPhoneWrapperStyled = styled.span`
  display: inline-block;
`;
HashedPhoneWrapperStyled.displayName = 'HashedPhoneWrapperStyled';

export { ContractOtpDescriptionWrapperStyled, ContractOtpWrapperStyled, HashedPhoneWrapperStyled };
